import React, { useState } from "react";
import "./legal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye} from "@fortawesome/free-solid-svg-icons";
function LegalDocuments() {
  const [selectedImage, setSelectedImage] = useState(null);

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <main>
         <div className="chitto">
        <div className="banner-contact">
          <img src="/img/company/legal.jpg" alt="help" />
          <div className="banner-contact-box"></div>
          <div className="contactus-header">
        <h1>Legal Document</h1>
        <p>We’re Legally Registered Company Under Law Of Nepal Government</p>
      </div>
      </div>
      </div>
    <div className="legal-container">
   

      <div className="legal-grid">
        {/* PAN CARD */}
        <div className="legal-card" onClick={() => openImage("/img/company/leg.jpg")}>
          <img src="/img/company/leg.jpg" alt="Pan Card" />
          <p>Company Registration (View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>

        {/* TOUR LICENSE */}
        <div className="legal-card" onClick={() => openImage("/img/company/leg1.jpg")}>
          <img src="/img/company/leg1.jpg" alt="Pan Card" />
          <p>Pan Card (View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>

        <div className="legal-card" onClick={() => openImage("/img/company/leg2.jpg")}>
          <img src="/img/company/leg2.jpg" alt="Pan Card" />
          <p>Tourist Guide Licence (View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        
        {/* SECOND COMPANY LICENSE */}
      </div>

      {/* MODAL */}
      {selectedImage && (
        <div className="legal-modal">
          <span className="legal-close" onClick={closeImage}>
            &times;
          </span>
          <img src={selectedImage} alt="Large View" />
        </div>
      )}
    </div>
    </main>
  );
}

export default LegalDocuments;